module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-HIPPO-Auto-Driver.93d8a96c.gif";